<template>
    <div id="contenedor-mapas-main">
      <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'MapasMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
